"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompanyByUrl = getCompanyByUrl;
exports.getCompanyById = getCompanyById;
exports.toggleCompanySubscription = toggleCompanySubscription;
exports.fetchCompanyCandidatesForSubscription = fetchCompanyCandidatesForSubscription;
exports.subscribeToCompanies = subscribeToCompanies;
exports.getMessageSettings = getMessageSettings;
exports.getCompanyApplicants = getCompanyApplicants;
exports.getCompany = getCompany;
exports.getCompaniesForList = getCompaniesForList;
exports.getCompaniesForListPreview = getCompaniesForListPreview;
exports.getCompaniesByIds = getCompaniesByIds;
exports.setCompanyInfo = setCompanyInfo;
exports.setCompanyImages = setCompanyImages;
exports.deleteCompanyImage = deleteCompanyImage;
exports.getAllCompaniesCount = getAllCompaniesCount;
exports.getCompanyRemovalInfo = getCompanyRemovalInfo;
exports.deleteCompanyData = deleteCompanyData;
const axios_1 = require("./clients/axios");
async function getCompanyByUrl(companyUrl) {
    const response = await axios_1.client.get(`/0/company/get-by-url/${companyUrl}`);
    return response.data;
}
async function getCompanyById(id) {
    const response = await axios_1.client.get(`/0/company/${id}`);
    return response.data;
}
async function toggleCompanySubscription(companyId) {
    const response = await axios_1.client.put('/0/company/toggle-subscription', {
        companyId,
    });
    return response.data;
}
async function fetchCompanyCandidatesForSubscription() {
    const response = await axios_1.client.get('/0/company/subscription-candidates');
    return response.data;
}
async function subscribeToCompanies(companyIds) {
    await axios_1.client.post('/0/company/batch-subscribe', { companyIds });
}
async function getMessageSettings() {
    const response = await axios_1.client.get('/0/company/message-settings');
    return response.data;
}
async function getCompanyApplicants(filterValues, page) {
    const { name, school, position } = filterValues;
    const response = await axios_1.client.get('/0/company/applicants', {
        params: {
            page,
            name,
            school,
            position,
        },
    });
    return response.data;
}
async function getCompany() {
    const response = await axios_1.client.get('/0/company');
    return response.data;
}
async function getCompaniesForList(search = '', page = 1) {
    const response = await axios_1.client.get('/0/company/list', { params: { search, page } });
    return response.data;
}
async function getCompaniesForListPreview(limit) {
    const response = await axios_1.client.get('/0/company/list-preview', { params: { limit } });
    return response.data;
}
async function getCompaniesByIds(companiesIds) {
    const response = await axios_1.client.get('/0/company/selected-companies', { params: { companiesIds } });
    return response.data;
}
async function setCompanyInfo(companyInfo) {
    const response = await axios_1.client.put('/0/company', companyInfo);
    return response.data;
}
async function setCompanyImages(image, titleImage) {
    const companyImages = new FormData();
    if (image) {
        companyImages.append('image', image);
    }
    if (titleImage) {
        companyImages.append('title_image_url', titleImage);
    }
    const response = await axios_1.client.put('/0/company/images', companyImages);
    return response.data;
}
async function deleteCompanyImage(imageType) {
    const response = await axios_1.client.delete('/0/company/image', { params: { imageType } });
    return response.data;
}
async function getAllCompaniesCount() {
    return (await axios_1.client.get('/0/company/count-all')).data;
}
async function getCompanyRemovalInfo() {
    return (await axios_1.client.get('/0/company/removal-info')).data;
}
async function deleteCompanyData() {
    return (await axios_1.client.delete('/0/company/remove-data')).data;
}
